import { Component, inject } from '@angular/core';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
    selector: 'brightside-web-mpap-initial-card',
    imports: [BrightsideUiModule],
    templateUrl: './mpap-initial-card.component.html',
    styleUrl: './mpap-initial-card.component.css'
})
export class MpapInitialCardComponent {
  actionCardConfig: ActionCardConfigInterface;

  private _translateSvc = inject(TranslateService);
  private _router = inject(Router);

  ngOnInit() {
    this.actionCardConfig = {
      label: this._translateSvc.instant('MPAP_INITIAL_LABEL'),
      title: this._translateSvc.instant('MPAP_INITIAL_TITLE'),
      labelIcon: '',
      cardStyle: 'small',
      image: './assets/mpap-init-card.png',
      backgroundSize: 'cover',
      marginBottom: 'small'
    }
  }

  navigate() {
    this._router.navigate(['program', 'mpap']);
  }
}
